import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';

import { Checkout2RoutingModule } from './checkout2-routing.module';
import { DirectivesModule } from '../../shared/directives/directives.module';

import { NotFoundComponent } from './components/not-found/not-found.component';
import { Checkout2Component } from './components/checkout2/checkout2.component';

import { TokenService } from '../../shared/services/token/token.service';
import { VendaService } from '../../shared/services/venda/venda.service';
import { CartaoService } from '../../shared/services/cartao/cartao.service';
import { ErrorReportingService } from '../../shared/services/error-reporting/error-reporting.service';

@NgModule({
  imports: [
    FormsModule,
    CommonModule,
    DirectivesModule,
    Checkout2RoutingModule,
    NgxMaskDirective
  ],
  declarations: [
    NotFoundComponent,
    Checkout2Component
  ],
  providers: [
    TokenService,
    VendaService,
    CartaoService,
    ErrorReportingService,
    provideNgxMask()
  ]
})
export class Checkout2Module { }
